import { render, staticRenderFns } from "./customermanagement.vue?vue&type=template&id=fd03f09c"
import script from "./customermanagement.vue?vue&type=script&lang=js"
export * from "./customermanagement.vue?vue&type=script&lang=js"
import style0 from "./customermanagement.vue?vue&type=style&index=0&id=fd03f09c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports